const regex = {
    search: {
        ngr: /^[S][CDEHJKMNOPRSTU]\s*[0-9]+\s*[0-9]+$/i,
        eastingNorthing: /^(\d+),\s*(\d+)$/,
        postcode: /^([A-Za-z]{1,2}[0-9]{1,2})$|^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/
    }
}

export default regex;
